import Text from "../../Components/Text/Text";
import Img1 from "../../assets/images/case-studies-ecospirits.jpg";
import Img2 from "../../assets/images/case-studies-engagerocket.jpg";
import Img3 from "../../assets/images/case-studies-dbs-2.jpg";
import { Link } from "react-router-dom";
import { useRef } from "react";
import { useWindowScroll } from "../../hooks/useWindowScroll";
import { useState } from "react";
import { useEffect } from "react";

const CASE_STUDIES = [
  {
    title: "ecoSPIRITS",
    description: 'Increased customer engagement by 3X through AI-driven personalization.',
    platform: ['Logistics', 'Mobile & Web Application', 'AI & Intelligent Automation'],
    image: Img1,
    path: "/case-studies/ecospirits",
  },
  {
    title: "EngageRocket",
    description: "Delivered a scalable MVP that secured $2M in funding.",
    platform: ['MVP', 'Mobile & Web Application'],
    image: Img2,
    path: "case-studies/engage-rocket",
  },
  {
    title: "DBS Insurance ",
    description: "Reduced policy processing time by 40% with intelligent automation.",
    platform: ['Insurance', 'Web Application'],
    image: Img3,
    path: "case-studies/dbs",
  },
];

export default function CaseStudiesSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();
  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 2;
  const show = y > boundary;

  return (
    <section className="pb-[120px] pt-[240px] max-md:pt-[120px]" ref={ref}>
      <div className="container mx-auto px-4 animate-fade-in-left">
        <Text type="h1" size="d5" className={`transition-all duration-700 delay-150 ${show ? "" : "opacity-0 translate-x-96"}`}>
          Real-World Success Stories That Matter
        </Text>
        <ul>
          {CASE_STUDIES.map((item, index) => (
            <Item key={index} {...item} show={show} />
          ))}
        </ul>
        <Link to="/case-studies">
          <Text 
            type="span" 
            className={`text-xl relative after:content-[''] inline-block after:inline-block after:w-full after:h-[2px] after:bg-yellow-500 after:absolute after:-bottom-3 after:left-0 transition-all duration-700 delay-150 ${show ? "" : "opacity-0 translate-y-96"}`}
          >
            VIEW ALL CASE STUDIES
          </Text>
        </Link>
      </div>
    </section>
  );
}

function Item({ title, description, platform, image, path, show, index }) {
  const [active, setActive] = useState(false);
  
  useEffect(() => {
    const time = show ? index * 200 : 0;
    const timeId = setTimeout(() => setActive(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  return (
    <Link to={path} rel="nofollow" className={`transition-all duration-700 ${active ? "" : "opacity-0 translate-y-96"}`}>
      <li className={`relative rounded-2xl overflow-hidden my-12 shadow-xl group transition-all duration-700 ${active ? "" : "opacity-0 translate-y-96"}`}>
        <img
          src={image}
          alt={title}
          className="w-full transition-all duration-700 group-hover:scale-110 h-[300px] sm:h-auto object-cover sm:object-contain"
        />
        <div className="absolute bottom-0 px-14 max-lg:px-6 max-lg:py-6 w-[60%] max-md:w-full pt-[72px] pb-14 flex flex-col justify-center transition-all">
          <Text size="d4" className="text-white mb-3">
            {title}
          </Text>
          <Text size="bodyLg" className="text-white md:max-md:max-w-[342px] tablet:max-w-[474px] lg:max-w-[690px] mb-1 max-sm:max-w-[340px] max-sm:text-xs">
            {description}
          </Text>
          <ol className="p-0 flex list-disc gap-3 max-sm:gap-2 text-white items-center mt-6 max-sm:mt-4 tablet:max-w-[474px] lg:max-w-[690px] flex-wrap md:max-md:max-w-[342px] max-sm:max-w-[227px]">
            {platform.map((item, index) => (
              <>
                {
                  index === 0 ? (
                    ''
                  ) : (
                    <div className="min-w-[4px] h-1 bg-white rounded-full" />
                  )
                }
                <li
                  key={index}
                  className={`list-none text-center`}
                >
                  <Text className="text-white block text-base font-semibold max-sm:text-xs">{item}</Text>
                </li>
              </>
            ))}
          </ol>
        </div>
      </li>
    </Link>
  );
}
